import icon from "../../assets/sound.svg";
import type { Property } from "../../types";

export const cameraAudio: Property = {
  id: "cameraAudio",
  title: "cameraAudio.title",
  icon,
};
